export default function EmployeeAllowanceCollection(getAllowanceRecord) {
    const record = [];
    for (let i = 0; i < getAllowanceRecord.length; i++) {
        const annualAllowances = getAllowanceRecord[i].annual_allowances

        let data = {
            id: `${getAllowanceRecord[i].id}`,
            employee: `${getAllowanceRecord[i].employee_name}`,
            staffNo: `${getAllowanceRecord[i].staff_no}`,
            position: `${getAllowanceRecord[i].position}`,
            active: `${getAllowanceRecord[i].active_label}`,
            location: getAllowanceRecord[i].location ? getAllowanceRecord[i].location.name : '',
            department: getAllowanceRecord[i].department ? getAllowanceRecord[i].department.name : '',
            sickTotal:getAllowanceRecord[i].sick_allowances.total ?? 0,
            sickTaken:getAllowanceRecord[i].sick_allowances.taken ?? 0,
        }

        for (let i = 0; i < 3; i++) {
            if (annualAllowances[i]) {
                data['total_' + annualAllowances[i].year] = annualAllowances[i].total ?? 0;
                data['taken_' + annualAllowances[i].year] = annualAllowances[i].taken ?? 0;
            }
        }

        record.push(data);
    }

    return record;
}
